// Carry-over expiry — the one line under a balance (DESIGN-rollover.md, 09/10/2026).
//
// ⚠️ ONLY BEFORE THE USE-BY DATE. After it, nothing on the card: Rob, 09/10/2026 — a line
// saying days expired would be "a constant kick in the teeth". They are told once (an email,
// or Teams), and the ? breakdown keeps one line so the balance still adds up.
//
// ⚠️ IN THE PERSON'S OWN UNIT (leaveUnits.js). Checked by carryOver.checks.mjs.
import { formatLeave, normUnit, HOURS } from './leaveUnits.js';
import { formatDateGB } from './dates.js';

const isSome = (days, minutes) => (Number(days) || 0) > 0.0001 || (Number(minutes) || 0) > 0;

/** "5 carried-over days" / "1 carried-over day" / "37h 30m of carried-over leave". */
export function carriedPhrase(days, minutes, unit) {
  if (normUnit(unit) === HOURS && minutes !== null && minutes !== undefined) {
    return `${formatLeave(days, { unit, minutes })} of carried-over leave`;
  }
  const n = formatLeave(days, { unit: 'days', withUnit: false });
  return `${n} carried-over ${Number(days) === 1 ? 'day' : 'days'}`;
}

/**
 * What the balance card says, or null to say nothing.
 *   { tone: 'due', carried, toUse, useBy }  — some not booked yet: "Use 3 more by …"
 *   { tone: 'ok',  carried, useBy }          — all booked for days on or before the date
 */
export function carryLine(allowance) {
  const ce = allowance && allowance.carry_expiry;
  if (!ce || ce.state !== 'due' || !ce.use_by) return null;
  if (!isSome(ce.carried_days, ce.carried_minutes)) return null;
  const unit = allowance.display_unit;
  const useBy = formatDateGB(ce.use_by);
  const carried = carriedPhrase(ce.carried_days, ce.carried_minutes, unit);
  if (isSome(ce.to_use_days, ce.to_use_minutes)) {
    const toUse = formatLeave(ce.to_use_days, { unit, minutes: ce.to_use_minutes });
    // "Use 2 more days by …" / "1 more day" / "37h 30m more" — read on screen, 09/10/2026:
    // "Use 2 days more by" was clumsy.
    const hours = normUnit(unit) === HOURS && ce.to_use_minutes !== null && ce.to_use_minutes !== undefined;
    const n = formatLeave(ce.to_use_days, { unit: 'days', withUnit: false });
    const more = hours ? `${toUse} more` : `${n} more ${Number(ce.to_use_days) === 1 ? 'day' : 'days'}`;
    return { tone: 'due', carried, useBy, toUse, more };
  }
  // "Your 5 carried-over days ARE all booked" / "Your 1 carried-over day IS" / "37h IS".
  return { tone: 'ok', carried, useBy, verb: carried.endsWith(' days') ? 'are' : 'is' };
}
